import { makeServerRequest } from './util';

const apiPrefix = "/api/v1/userinfo";

export const getAuthSuccess = (data) => {

    return {
        type: "FETCH_AUTH_SUCCESS",
        payload: data
    };
};

export const getAuthFailure = (error) => {

    return {
        type: "FETCH_AUTH_FAILURE",
        payload: error
    };
};

export const getAuth = () => {

    return (dispatch) => {
        dispatch({type: "FETCH_AUTH"});

        return makeServerRequest(apiPrefix).then(
            response => dispatch(getAuthSuccess(response.data))
        ).catch(
            error => dispatch(getAuthFailure(error))
        );
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/auth.js